import React from 'react';
import {Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@mui/material";
import {connect} from 'react-redux';
import {useTranslation} from "react-i18next";
import {CLEAR_SERVER_ERROR} from "../../../redux/constants";


const GenericErrorModal = (props) => {

    const {t} = useTranslation();

    let serverState = props.errorModalState.toJS();

    return (
        <Dialog
            open={serverState.hasServerError}
        >
            <DialogTitle id={'error-dialog'} color={'validation'}>{t('Global.server_error')}</DialogTitle>
            <DialogContent>
                <Typography control={'p'} variant={'body1'} color={'validation'}>
                    {t('Global.server_error_message')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    color={'primary'}
                    variant={'contained'}
                    onClick={() => props.clearServerError()}
                >
                    {t('Global.ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        errorModalState: state.uxStateReducer.get("serverError")
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearServerError: () => dispatch({
            type: CLEAR_SERVER_ERROR
        })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericErrorModal);